// extracted by mini-css-extract-plugin
var _1 = "ReportBodyHeader__back--AHNJ0";
var _2 = "ReportBodyHeader__backHidden--zrJ2A";
var _3 = "ReportBodyHeader__bao--lx4tJ SchoolGeneral__bao--hA8gR OfficeGeneral__baoFont--nS_70 CoreGeneral__baoFont--dcsOj";
var _4 = "ReportBodyHeader__buttons--M2KOy";
var _5 = "ReportBodyHeader__classYear--TwB4s";
var _6 = "ReportBodyHeader__csvExportButton--rgeps SchoolGeneral__button--ZIm36";
var _7 = "ReportBodyHeader__days--TajA6 ReportBodyHeader__dropdown--uFT0K";
var _8 = "ReportBodyHeader__dropdown--uFT0K";
var _9 = "ReportBodyHeader__filter--UdVOP ReportBodyHeader__dropdown--uFT0K";
var _a = "ReportBodyHeader__filters--HBibn";
var _b = "ReportBodyHeader__gradeFilter--dEqjC ReportBodyHeader__filter--UdVOP ReportBodyHeader__dropdown--uFT0K";
var _c = "ReportBodyHeader__levelFilter--uzMSK ReportBodyHeader__filter--UdVOP ReportBodyHeader__dropdown--uFT0K";
var _d = "ReportBodyHeader__link--n6kTB";
var _e = "ReportBodyHeader__main--LL2X_";
var _f = "ReportBodyHeader__mainBorder--Y1jTj ReportBodyHeader__main--LL2X_";
var _10 = "ReportBodyHeader__name--nvLmU CoreGeneral__robotoMedium--xrjYk";
var _11 = "ReportBodyHeader__printLogo--VqHXE";
var _12 = "ReportBodyHeader__printLogoWrapper--Ryma3";
var _13 = "ReportBodyHeader__selectedTab--RdSRq SchoolGeneral__selectedTab--SHgXj SchoolGeneral__tab--QFSwN ReportBodyHeader__tabBase--dqjGh";
var _14 = "ReportBodyHeader__singleFilter--yUoP6 ReportBodyHeader__filters--HBibn";
var _15 = "ReportBodyHeader__static--xzyno";
var _16 = "ReportBodyHeader__summary--lq9WC";
var _17 = "ReportBodyHeader__summaryStats--K3FWW";
var _18 = "ReportBodyHeader__tab--DZo1M SchoolGeneral__tab--QFSwN ReportBodyHeader__tabBase--dqjGh";
var _19 = "ReportBodyHeader__tabBase--dqjGh";
var _1a = "ReportBodyHeader__tabIcon--aI07O";
var _1b = "ReportBodyHeader__topRight--A628V";
var _1c = "ReportBodyHeader__topRow--fVMMZ";
var _1d = "ReportBodyHeader__yearFilter--Gb73Q ReportBodyHeader__filter--UdVOP ReportBodyHeader__dropdown--uFT0K";
export { _1 as "back", _2 as "backHidden", _3 as "bao", _4 as "buttons", _5 as "classYear", _6 as "csvExportButton", _7 as "days", _8 as "dropdown", _9 as "filter", _a as "filters", _b as "gradeFilter", _c as "levelFilter", _d as "link", _e as "main", _f as "mainBorder", _10 as "name", _11 as "printLogo", _12 as "printLogoWrapper", _13 as "selectedTab", _14 as "singleFilter", _15 as "static", _16 as "summary", _17 as "summaryStats", _18 as "tab", _19 as "tabBase", _1a as "tabIcon", _1b as "topRight", _1c as "topRow", _1d as "yearFilter" }
